import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { isAutheticated } from "../../auth/authhelper";
import { API } from "../../../API";
import Footer from "../Footer";
import ReactApexChart from "react-apexcharts";
import { Tab, Tabs } from "react-bootstrap";

const ReportVideos = () => {
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const revMonthNames = [...monthNames].reverse();

  const { token } = isAutheticated();
  const [allVideosDetails, setAllVideosDetails] = useState([]);
  const [videosInYear, setVideosInYear] = useState([]);

  const [loading, setLoading] = useState(true);

  const [allYears, setAllYears] = useState([]);
  const [year, setYear] = useState(false);
  const [monthVideosDetails, setMonthVideosDetails] = useState([]);
  const [month, setMonth] = useState(-1);
  const [monthDays, setMonthDays] = useState([]);
  const [monthDaysVideos, setMonthDaysVideos] = useState([]);

  const currentDate = useRef(new Date());

  useEffect(() => {
    axios
      .get(`${API}/api/lesson/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        let data = response.data.data;
        setAllVideosDetails(data);
        setLoading(false);
        let tempYears = [];
        for (var i = 0; i < data.length; i++) {
          let tempYear = new Date(data[i].createdAt).getFullYear();
          let check = tempYears.find((e) => e === tempYear);
          if (!check) {
            tempYears.push(tempYear);
          }
        }
        if (tempYears.includes(currentDate.current.getFullYear()))
          setYear(currentDate.current.getFullYear());
        else setYear(tempYears[0]);
        setMonth(currentDate.current.getMonth());
        setAllYears(tempYears.reverse());
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, [token]);

  useEffect(() => {
    let temp2 = [];
    let sum = 0;
    for (var j = 0; j <= 11; j++) {
      let check = false;
      for (var i = 0; i < allVideosDetails.length; i++) {
        let tempMonth = new Date(allVideosDetails[i].createdAt).getMonth();
        let tempYear = new Date(allVideosDetails[i].createdAt).getFullYear();
        if (j === tempMonth && tempYear === year) {
          sum = sum + 1;
          check = true;
        }
      }
      if (!check) {
        temp2.push(temp2[temp2.length - 1] || 0);
      } else {
        temp2.push(sum);
      }
    }
    setVideosInYear(temp2);
  }, [allVideosDetails, year]);

  useEffect(() => {
    if (month !== -1) {
      let tempDays = [];
      let daysInMonth = new Date(year, parseInt(month) + 1, 0).getDate();
      for (let i = 1; i <= daysInMonth; i++) {
        tempDays.push(i);
      }
      setMonthDays(tempDays);
      const temp = allVideosDetails.filter((item) => {
        let tempMonth = new Date(item.createdAt).getMonth();
        let tempYear = new Date(item.createdAt).getFullYear();
        return tempMonth === month && tempYear === year;
      });
      setMonthVideosDetails(temp);
    }
  }, [month, allVideosDetails, year]);

  useEffect(() => {
    let tempMonth = [];
    let sum = 0;
    for (var j = 1; j <= monthDays.length; j++) {
      let check = false;
      for (var i = 0; i < monthVideosDetails.length; i++) {
        let tempDay = new Date(monthVideosDetails[i].createdAt).getDate();
        if (j === tempDay) {
          sum = sum + 1;
          check = true;
        }
      }
      if (!check) {
        tempMonth.push(tempMonth[tempMonth.length - 1] || 0);
      } else {
        tempMonth.push(sum);
      }
    }
    setMonthDaysVideos(tempMonth);
  }, [monthVideosDetails, monthDays]);

  const apexOptions = {
    series: [
      {
        name: "Videos",
        data: videosInYear,
      },
    ],
    options: {
      chart: {
        height: 350,
        type: "line",
        zoom: {
          enabled: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "straight",
      },
      title: {
        text: "Yearly Videos Uploaded",
        align: "left",
      },
      grid: {
        row: {
          colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
          opacity: 0.5,
        },
      },
      xaxis: {
        categories: monthNames,
      },
    },
  };

  const apexOptionsForMonth = {
    series: [
      {
        name: "Videos",
        data: monthDaysVideos,
      },
    ],
    options: {
      chart: {
        height: 350,
        type: "line",
        zoom: {
          enabled: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "straight",
      },
      title: {
        text: "Monthly Videos Uploaded",
        align: "left",
      },
      grid: {
        row: {
          colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
          opacity: 0.5,
        },
      },
      xaxis: {
        categories: monthDays,
      },
    },
  };
  return (
    <div className='main-content'>
      <div className='page-content'>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-12'>
              <div className='page-title-box d-flex align-items-center justify-content-between'>
                <h4 className='mb-0'>Videos</h4>

                <div className='page-title-right'>
                  <ol className='breadcrumb m-0'>
                    <li className='breadcrumb-item'>
                      <Link to='/dashboard'>SoComOTT</Link>
                    </li>
                    <li className='breadcrumb-item active'>Reports - Videos</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-12'>
              <div className='card'>
                <div className='card-body'>
                  <div className='text-center'>{loading && "loading..."}</div>
                  <Tabs
                    defaultActiveKey='yearly'
                    id='uncontrolled-tab-example'
                    className='mb-3'>
                    <Tab eventKey='yearly' title='Yearly'>
                      <label className='w-100 ms-2'>
                        Select Year
                        <select
                          name=''
                          className='form-control-sm form-control w-25'
                          value={year}
                          onChange={(e) => setYear(parseInt(e.target.value))}>
                          {allYears.map((item, index) => {
                            return (
                              <option value={item} key={index}>
                                {item}
                              </option>
                            );
                          })}
                        </select>
                      </label>
                      <div
                        className='my-2'
                        style={{
                          width: "100%",
                          height: "400px",
                        }}>
                        <ReactApexChart
                          options={apexOptions.options}
                          series={apexOptions.series}
                          type='line'
                          height={400}
                        />
                      </div>
                    </Tab>
                    <Tab eventKey='monthly' title='Monthly'>
                      <label className='w-100 ms-2'>
                        Select Month
                        <select
                          name=''
                          className='form-control-sm form-control w-25'
                          onChange={(e) => {
                            setMonth(parseInt(e.target.value.split(",")[1]));
                            setYear(parseInt(e.target.value.split(",")[0]));
                          }}
                          value={`${year},${month}`}>
                          {allYears.map((yearItem, yearIndex) => {
                            return revMonthNames.map((item, index) => {
                              let currentMonth = currentDate.current.getMonth();
                              let currentYear =
                                currentDate.current.getFullYear();
                              if (yearItem > currentYear) {
                                return null;
                              }
                              if (
                                11 - index > currentMonth &&
                                yearItem === currentYear
                              ) {
                                return null;
                              }
                              return (
                                <option
                                  value={[yearItem, 11 - index]}
                                  key={index}>
                                  {item}-{yearItem}
                                </option>
                              );
                            });
                          })}
                        </select>
                      </label>
                      {month !== -1 && (
                        <label className='ms-2'>
                          Total Videos Uploaded: &nbsp;
                          {monthDaysVideos[monthDaysVideos.length - 1]}
                        </label>
                      )}
                      <div
                        className='my-2'
                        style={{
                          width: "100%",
                          height: "400px",
                        }}>
                        <ReactApexChart
                          options={apexOptionsForMonth.options}
                          series={apexOptionsForMonth.series}
                          type='line'
                          height={400}
                        />
                      </div>
                    </Tab>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ReportVideos;
